module.exports = __webpack_public_path__ + "static/media/IMG_0259.669f0dd2.PNG";